<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import StaticModal from "./static_modal.vue";
import Loader from "../../../components/widgets/loader.vue";

export default {
    page: {
    title: "Sabit Sms Şablonları",
    meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: {
        Layout,
        PageHeader,
        StaticModal,
        Loader,
    },
    data(){
        return {
            title: "SABİT SMS ŞABLONLARI",
            items: [
                {
                    text: "ANASAYFA",
                    href: "/",
                },
                {
                    text: "SABİT SMS ŞABLONLARI",
                    active: true,
                },
            ],
            dataLoading:true,
            list:{},
            projectData: []
        }
    },
    mounted(){
      this.getList()
    },
    methods:{
        getList(){
            this.$http.post(`/system-sms`)
              .then(resp => {
                  this.projectData = resp.data
              })
              .catch(error => error)
              .finally(() => this.dataLoading=false)
        },
        edit(params){
            this.list = { ...params }
            this.$parent.$bvModal.show('modal-scoped')
        },
    }
}
</script>
<template>
 <Layout>
    <PageHeader :title="title" :items="items" />
    <static-modal :list="list" @loadItems="getList()"/>
    <Loader :loading="true" :load="dataLoading">
    <div class="row">
      <div class="col-lg-12">
        <div>
          <div class="table-responsive">
            <table
              class="table project-list-table  table-centered table-borderless align-middle"
            >
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col" style="width:20%">Tanım</th>
                  <th scope="col">İçerik</th>
                  <th scope="col">Tetikleneceği Zaman</th>
                  <th scope="col" style="width:5%"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="project in projectData" :key="project.id" >
                  <td>
                    <h5 class="text-truncate font-size-14">
                     {{ project.id }}
                    </h5>
                  </td>
                  <td>
                    <h5 class="text-truncate font-size-14">
                     {{ project.title }}
                    </h5>
                    <span class="badge rounded-pill bg-success" v-if="project.status == 1">Aktif</span>
                    <span class="badge rounded-pill bg-danger" v-else>Pasif</span>
                  </td>
                  <td>{{ project.content }}</td>
                  <td> 
                      <span v-if="project.trigera">{{ project.trigera }} Gün kala /geçe , </span>
                      <span v-if="project.trigerb">Saat {{ project.trigerb }} </span>
                  </td>
                 <td>
                     <button 
                    class="btn btn-info btn-sm" 
                    type="button" 
                    @click="edit(project)"
                    >  <i class="bx bx-search-alt-2"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    </Loader>
  </Layout>
</template>